/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Template_StarterInputs */

const en_ccsl_export_template_starter = /** @type {(inputs: Ccsl_Export_Template_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter Format`)
};

const fr_ccsl_export_template_starter = /** @type {(inputs: Ccsl_Export_Template_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format debutant`)
};

const de_ccsl_export_template_starter = /** @type {(inputs: Ccsl_Export_Template_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starterformat`)
};

const it_ccsl_export_template_starter = /** @type {(inputs: Ccsl_Export_Template_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato di partenza`)
};

const ru_ccsl_export_template_starter = /** @type {(inputs: Ccsl_Export_Template_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начальный формат`)
};

const es_ccsl_export_template_starter = /** @type {(inputs: Ccsl_Export_Template_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato de inicio`)
};

const zh_cn2_ccsl_export_template_starter = /** @type {(inputs: Ccsl_Export_Template_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入门格式`)
};

const ja_ccsl_export_template_starter = /** @type {(inputs: Ccsl_Export_Template_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スターターフォーマット`)
};

const hi_ccsl_export_template_starter = /** @type {(inputs: Ccsl_Export_Template_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टार्टर प्रारूप`)
};

const pt_pt2_ccsl_export_template_starter = /** @type {(inputs: Ccsl_Export_Template_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato inicial`)
};

/**
* | output |
* | --- |
* | "Starter Format" |
*
* @param {Ccsl_Export_Template_StarterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_template_starter = /** @type {((inputs?: Ccsl_Export_Template_StarterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Template_StarterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_template_starter(inputs)
	if (locale === "de") return de_ccsl_export_template_starter(inputs)
	if (locale === "it") return it_ccsl_export_template_starter(inputs)
	if (locale === "ru") return ru_ccsl_export_template_starter(inputs)
	if (locale === "es") return es_ccsl_export_template_starter(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_template_starter(inputs)
	if (locale === "ja") return ja_ccsl_export_template_starter(inputs)
	if (locale === "hi") return hi_ccsl_export_template_starter(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_template_starter(inputs)
	return en_ccsl_export_template_starter(inputs)
});